import DownloadAppBannerPresenter from './DownloadAppBannerPresenter';
export default DownloadAppBannerPresenter;
